<template>
  <div class="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 mb-8 sticky top-4">
    <div class="p-6">
      <h2 class="text-lg font-semibold mb-4">Preview</h2>
      
      <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
        <!-- Tool Header Preview -->
        <div class="bg-white rounded-lg shadow-sm overflow-hidden border border-gray-200 mb-4">
          <div class="p-4">
            <div class="flex items-start gap-4">
              <div v-if="tool.icon && tool.category_color" class="flex-shrink-0">
                <div class="w-12 h-12 rounded-full flex items-center justify-center" :class="`bg-${tool.category_color}-100`">
                  <i :class="`${tool.icon} text-${tool.category_color}-500`"></i>
                </div>
              </div>
              
              <div>
                <div class="flex items-center gap-2 mb-1">
                  <h3 class="text-lg font-semibold">{{ tool.name || 'Tool Name' }}</h3>
                  <span v-if="tool.category" class="inline-block px-2 py-0.5 rounded-full text-xs font-medium" 
                    :class="`bg-${tool.category_color}-100 text-${tool.category_color}-700`">
                    {{ tool.category }}
                  </span>
                </div>
                <p class="text-sm text-gray-600">{{ tool.description || 'Tool description will appear here.' }}</p>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Input Form Preview -->
        <div class="bg-white rounded-lg shadow-sm overflow-hidden border border-gray-200 mb-4">
          <div class="p-4">
            <div v-if="tips && tips.length" class="bg-blue-50 rounded-md p-3 mb-4 border border-blue-100">
              <h4 class="text-sm font-medium text-blue-800 mb-2 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Tips for best results
              </h4>
              <ul class="list-disc pl-5 text-xs text-blue-800">
                <li v-for="(tip, index) in displayTips" :key="index">{{ tip }}</li>
              </ul>
            </div>
            
            <div v-if="tool.prompt_required" class="mb-4">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                {{ tool.prompt_label || 'What would you like to create?' }}
              </label>
              <div class="w-full h-24 bg-gray-100 rounded-md border border-gray-300"></div>
            </div>
            
            <div v-if="tool.input_required" class="mb-4">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                {{ tool.input_label || 'Input' }}
              </label>
              <div class="w-full h-24 bg-gray-100 rounded-md border border-gray-300"></div>
            </div>
            
            <div v-if="tool.tone_required" class="mb-4">
              <label class="block text-sm font-medium text-gray-700 mb-1">Tone</label>
              <div class="w-full h-10 bg-gray-100 rounded-md border border-gray-300"></div>
            </div>
            
            <div>
              <div class="w-full py-2 rounded-md text-center text-white font-medium" 
                :class="tool.category_color ? `bg-${tool.category_color}-500` : 'bg-blue-500'">
                {{ tool.action_label || 'Generate Content' }}
              </div>
            </div>
          </div>
        </div>
        
        <!-- Output Preview -->
        <div class="bg-white rounded-lg shadow-sm overflow-hidden border border-gray-200">
          <div class="p-4">
            <h4 class="text-lg font-medium mb-2">{{ tool.output_description || 'Generated Content' }}</h4>
            <div class="w-full h-32 bg-gray-100 rounded-md border border-gray-300"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolPreview',
  props: {
    tool: {
      type: Object,
      required: true
    },
    tips: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    displayTips() {
      return this.tips.filter(tip => tip && tip.trim() !== '')
    }
  }
}
</script> 